// extracted by mini-css-extract-plugin
export default {"card":"RedirectQuestaGlobal_card__aFQd-","b2":"RedirectQuestaGlobal_b2__QmwvP","b1":"RedirectQuestaGlobal_b1__GK6PK"};